import * as React from 'react';
import { useSelector } from 'react-redux';

import {
  basketStatus,
  isAnyBookingItemAirbnb,
  isBookingConfirmFinished,
} from '@src/shared/src/selectors/checkoutSelectors';
import { t } from '@toolkit/util/i18n';
import { InformationOverlay } from '@toolkit/ui';
import { STATUS } from '@src/shared/src/const/app';
import { CheckCircle } from '@toolkit/ui/icons/CheckCircle';
import { useAwaitingFlexLaneContract } from './FlexLaneContractWaitProvider';

export const CheckoutOverlayMessages: React.FC = () => {
  const bookingHasAirbnb = useSelector(isAnyBookingItemAirbnb);
  const bookingConfirmFinished = useSelector(isBookingConfirmFinished);
  const status = useSelector(basketStatus) as STATUS;
  // The booking is done either way, but the FlexLane cover it may still be waiting for belongs in the same
  // outcome (lanes-planes/backend#15086): congratulating the customer and then telling them the cover is
  // missing reads as two contradicting answers.
  const awaitingFlexLaneContract = useAwaitingFlexLaneContract();
  const bookingComplete = status === STATUS.CONFIRM_FINISHED && !awaitingFlexLaneContract;

  const confirmOverlayTextBody =
    bookingHasAirbnb && bookingConfirmFinished
      ? t('checkout-overlay-messages.text.airbnb-booking')
      : t('informationOverlay.body.bookingSuccess');

  return (
    <InformationOverlay
      key={`info-overlay-confirm-${bookingComplete}`}
      isOpen={bookingComplete}
      icon={<CheckCircle />}
      title={
        bookingHasAirbnb
          ? t('checkout-overlay-messages.title.congratulation-airbnb')
          : t('informationOverlay.title.congratulation')
      }
      body={confirmOverlayTextBody}
      showButton={true}
      buttonText={t('informationOverlay.button.proceedConfirmation')}
    />
  );
};
